import {IHomeContentBoxDataItem, IHomeListItem} from "./IHomeListItem";
import {IStrategyUpdate, StrategyUpdateType} from "./IStrategyUpdate.model";

export class MeetingNoteSummary implements IStrategyUpdate, IHomeListItem {
    public static builder() {
        return new MeetingNoteSummaryBuilder();
    }

    constructor(public backstopId: number,
                public title: string,
                public date: Date,
                public managerIds: number[],
                public productIds: number[],
                public hasProductAttachment: boolean | undefined,
                public fileName: string,
                public urlPrefix: string = "meeting-notes",
                public type: StrategyUpdateType = StrategyUpdateType.MEETING_NOTE,
    ) {
    }

    public transform(): IHomeContentBoxDataItem {
        return {
            title: this.title,
            date: this.date,
            backstopId: this.backstopId,
            url: `/${this.urlPrefix}/${this.backstopId}`,
            type: "Meeting Note",
        };
    }
}

class MeetingNoteSummaryBuilder {
    private mTitle: string;
    private mDate: Date;
    private mBackstopId: number;
    private mManagerIds: number[];
    private mProductIds: number[];
    private mHasProductAttachment: boolean | undefined;
    private mFileName: string;

    public backstopId(value: number) {
        this.mBackstopId = value;
        return this;
    }

    public title(value: string) {
        this.mTitle = value;
        return this;
    }

    public date(value: Date) {
        this.mDate = value;
        return this;
    }

    public managerIds(value: number[]) {
        this.mManagerIds = value;
        return this;
    }

    public productIds(value: number[]) {
        this.mProductIds = value;
        return this;
    }

    public hasProductAttachment(value: boolean) {
        this.mHasProductAttachment = value;
        return this;
    }

    public fileName(value: string) {
        this.mFileName = value;
        return this;
    }

    public build() {
        return new MeetingNoteSummary(
            this.mBackstopId || 0,
            this.mTitle || "title",
            this.mDate || new Date(0),
            this.mManagerIds || [],
            this.mProductIds || [],
            this.mHasProductAttachment,
            this.mFileName || "file name",
        );
    }
}

export class MeetingNoteSummaryLatest extends MeetingNoteSummary {
    constructor(public backstopId: number,
                public title: string,
                public date: Date,
                public managerIds: number[],
                public productIds: number[],
                public hasProductAttachment: boolean | undefined,
                public fileName: string,
                public urlPrefix: string = "meeting-notes",
                public type: StrategyUpdateType = StrategyUpdateType.MEETING_NOTE,
                public isExternal: boolean,
                public requested: boolean
    ) {
        super(
            backstopId,
            title,
            date,
            managerIds,
            productIds,
            hasProductAttachment,
            fileName,
            urlPrefix,
            type,
        );
        this.isExternal = isExternal;
        this.requested = requested;
    }

    public transform(): IHomeContentBoxDataItem {
        return super.transform();
    }
}
